// src/pages/About/about.js
import React from "react";
import "./about.css";

const About = () => {
  return (
   
      
      <div className="about-container ">
         <div className="about-overlayer">
         <div className="left-about">
          <img
            src="https://t3.ftcdn.net/jpg/06/50/81/08/360_F_650810877_QZ6C4qFsen46Q7d06pjveTcPDeqAAIJj.jpg"
            alt=""
          />
        </div>
        <div className="right-about">
          <h1> Truth Experienced inspires personal growth and discovery.</h1>
          <p className="about-description">
            <br />
            In a world full of noise, I created this space to inspire
            individuals to step into their own power by embracing courage and
            self-exploration. True love, deep connection, and true growth only
            emerge when we have the bravery to question everything—our beliefs,
            our experiences, and the world around us. It is through this courage
            to ask the difficult questions, to not simply accept the answers of
            others, but to embark on a personal journey of discovery, that we
            find our own truth. <br />
            <br />
            We live in a world where many people simply follow established
            norms, but real transformation comes from seeking and experiencing
            life on your own terms. This platform aims to encourage everyone to
            dare to be different, to challenge the status quo, and to trust the
            process of finding one’s own path.
            <br />
            <br />
            My personal journey has been one of constant questioning and
            learning, and it is through this lens that I now share my
            experiences with you. It is through your own experiences that you
            will discover the profound truth that lie within.{" "}
          </p>
        </div>
         </div>
      </div>
   
  );
};

export default About;
